var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bf",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de0000",
    d: "M512 511.6H.5V0H512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35a100",
    d: "M511.8 512H0V256.2h511.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff300",
    fillRule: "evenodd",
    d: "m389 223.8-82.9 56.5 31.7 91.6-82.7-56.7-82.8 56.7 31.7-91.6-82.8-56.6 102.3.2 31.6-91.7 31.5 91.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBf);
export default __webpack_public_path__ + "static/media/bf.bb616c9ec60cde6806bbc1c62b4e2a6d.svg";
export { ForwardRef as ReactComponent };